var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div class=\"settings\"><div ng-style=\"{'background': (!mobile_view &amp;&amp; current_state === 'root.dashboard.settings.company' ? '#fff' : '')}\" class=\"wrapper-main\"><div ui-view=\"\"></div></div></div>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./components/dashboard/settings/settings.jade
// module id = 769
// module chunks = 0